import type { TwiageCase } from "@/App/types/twiageTypes";
import type { User } from "@/App/user/User";

export const canUserAnswerLiveConsult = ({
  twiageCase,
  user,
}: {
  twiageCase: TwiageCase;
  user: User | null;
}): boolean => {
  const destinationHospitalId = twiageCase.destinationHospital?.id;
  if (destinationHospitalId && user) {
    return user.hospitals?.some((hospital) => hospital.id === destinationHospitalId && hospital.videoConsultant);
  }
  return false;
};
